"use strict";

exports.__esModule = true;
exports.CalendarController = CalendarController;
var _react = _interopRequireWildcard(require("react"));
var _libCalendar = require("@vimana/lib-calendar");
var _CalendarLoader = require("../CalendarLoader");
var _Core = require("../../Core");
var _API = require("../../API");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _dec, _dec2, _class, _InnerCalendarController;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var InnerCalendarController = (_dec = _API.RestAPIContext.withContext, _dec2 = _DataAccessorContext.DataAccessorContext.withContext, _dec(_class = _dec2(_class = (_InnerCalendarController = /*#__PURE__*/function (_Component) {
  function InnerCalendarController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      consumable: {
        calendar: _this.props.calendar,
        actions: {
          refresh: function () {
            var _refresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
              var dataAccessor, _yield$dataAccessor$g, timezone, events, schedules, config, calendar;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    dataAccessor = _this.props.dataAccessor;
                    _this.setState({
                      isLoading: true
                    });
                    _context.n = 1;
                    return dataAccessor.getCalendar();
                  case 1:
                    _yield$dataAccessor$g = _context.v;
                    timezone = _yield$dataAccessor$g.timezone;
                    events = _yield$dataAccessor$g.events;
                    schedules = _yield$dataAccessor$g.schedules;
                    config = {
                      timezone: timezone,
                      events: events,
                      schedules: schedules
                    };
                    calendar = new _libCalendar.Calendar(config);
                    _this.setState(function (prevState) {
                      return {
                        isLoading: false,
                        consumable: Object.assign({}, prevState.consumable, {
                          calendar: calendar
                        })
                      };
                    });
                  case 2:
                    return _context.a(2);
                }
              }, _callee);
            }));
            function refresh() {
              return _refresh.apply(this, arguments);
            }
            return refresh;
          }(),
          createSchedule: function () {
            var _createSchedule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(schedule) {
              var _this$props, api, dataAccessor, createdSchedule, _yield$dataAccessor$g2, timezone, events, schedules, config, calendar;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    _this.setState({
                      isLoading: true
                    });
                    _this$props = _this.props, api = _this$props.api, dataAccessor = _this$props.dataAccessor;
                    _context2.n = 1;
                    return api.post("/api/v3/calendar/schedule", schedule);
                  case 1:
                    createdSchedule = _context2.v;
                    _context2.n = 2;
                    return dataAccessor.getCalendar();
                  case 2:
                    _yield$dataAccessor$g2 = _context2.v;
                    timezone = _yield$dataAccessor$g2.timezone;
                    events = _yield$dataAccessor$g2.events;
                    schedules = _yield$dataAccessor$g2.schedules;
                    config = {
                      timezone: timezone,
                      events: events,
                      schedules: schedules
                    };
                    calendar = new _libCalendar.Calendar(config);
                    _this.setState(function (prevState) {
                      return {
                        isLoading: false,
                        consumable: Object.assign({}, prevState.consumable, {
                          calendar: calendar
                        })
                      };
                    });
                    return _context2.a(2, createdSchedule);
                }
              }, _callee2);
            }));
            function createSchedule(_x) {
              return _createSchedule.apply(this, arguments);
            }
            return createSchedule;
          }(),
          updateSchedule: function () {
            var _updateSchedule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id, schedule) {
              var api;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    api = _this.props.api;
                    return _context3.a(2, api.put("/api/v3/calendar/schedule/" + id, schedule));
                }
              }, _callee3);
            }));
            function updateSchedule(_x2, _x3) {
              return _updateSchedule.apply(this, arguments);
            }
            return updateSchedule;
          }(),
          createCalendarEvent: function () {
            var _createCalendarEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(event) {
              var api;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    api = _this.props.api;
                    return _context4.a(2, api.post("/api/v3/calendar/event", event));
                }
              }, _callee4);
            }));
            function createCalendarEvent(_x4) {
              return _createCalendarEvent.apply(this, arguments);
            }
            return createCalendarEvent;
          }(),
          updateCalendarEvent: function () {
            var _updateCalendarEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id, event) {
              var api;
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    api = _this.props.api;
                    return _context5.a(2, api.put("/api/v3/calendar/event/" + id, event));
                }
              }, _callee5);
            }));
            function updateCalendarEvent(_x5, _x6) {
              return _updateCalendarEvent.apply(this, arguments);
            }
            return updateCalendarEvent;
          }(),
          deleteCalendarEvent: function () {
            var _deleteCalendarEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(id) {
              var api;
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.n) {
                  case 0:
                    api = _this.props.api;
                    return _context6.a(2, api["delete"]("/api/v3/calendar/event/" + id));
                }
              }, _callee6);
            }));
            function deleteCalendarEvent(_x7) {
              return _deleteCalendarEvent.apply(this, arguments);
            }
            return deleteCalendarEvent;
          }(),
          setTimezone: function () {
            var _setTimezone = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(name) {
              var api;
              return _regenerator().w(function (_context7) {
                while (1) switch (_context7.n) {
                  case 0:
                    api = _this.props.api;
                    return _context7.a(2, api.put("/api/v3/calendar/timezone", {
                      name: name
                    }));
                }
              }, _callee7);
            }));
            function setTimezone(_x8) {
              return _setTimezone.apply(this, arguments);
            }
            return setTimezone;
          }()
        }
      },
      isLoading: false
    };
    return _this;
  }
  _inheritsLoose(InnerCalendarController, _Component);
  var _proto = InnerCalendarController.prototype;
  _proto.render = function render() {
    var children = this.props.children;
    var _this$state = this.state,
      consumable = _this$state.consumable,
      isLoading = _this$state.isLoading;
    if (isLoading) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    }
    return children(consumable);
  };
  return InnerCalendarController;
}(_react.Component), _InnerCalendarController.defaultProps = {
  api: undefined,
  dataAccessor: undefined
}, _InnerCalendarController)) || _class) || _class);
function CalendarController(props) {
  return /*#__PURE__*/_react["default"].createElement(_CalendarLoader.CalendarLoader, null, function (loaderProps) {
    return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, loaderProps, function (calendar) {
      return /*#__PURE__*/_react["default"].createElement(InnerCalendarController, _extends({
        calendar: calendar
      }, props));
    });
  });
}